import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Section } from '../Section';
import { InView } from '../InView';
import { SectionHeadline } from '../SectionHeadline';
import { SnakStill } from '../../SnakStill';
import { snakArc, snakPrinciples, snakWalkthrough } from '../../../data/deck';
export function ChallengeSection() {
  return <Section id="challenge" data-id="element-309" data-mp="37ycn2tzlpmvg">
      <div className="grid items-end gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,0.9fr)] lg:gap-16" data-id="element-310" data-mp="2abdogdpcm4ux">
        <InView data-id="element-311" data-mp="2fagw85wpqp6l">
          <SectionHeadline lead="HCPs don’t lack content." follow="They lack time." data-id="element-312" data-mp="2f9ypuggc6uky" />
        </InView>
        <InView delay={0.1} data-id="element-313" data-mp="2k91s5t4xmmp8">
          <div className="border-l-2 border-[var(--brand)] pl-5" data-id="element-314" data-mp="2k8s0800bu5gw">
            <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-[var(--muted)]" data-id="element-315" data-mp="2oboh9ma7xtiq">So we created the Snak.</p>
            <p className="mt-1.5 text-[24px] font-extrabold leading-tight tracking-[-0.025em] text-[var(--fg)]" data-id="element-316" data-mp="3vnylhf85fy2e">
              A short story you participate in.
            </p>
            <p className="mt-3 max-w-[48ch] text-[14.5px] leading-[1.65] text-[var(--muted)]" data-id="element-317" data-mp="30886wvf7g3ak">
              A Snak turns complex content into a short, engaging journey. HCPs don’t just read or watch — they choose, react
              and discover.
            </p>
          </div>
        </InView>
      </div>

      <InView delay={0.16} className="mt-10" data-id="element-318" data-mp="2m8p5smkt9s7r">
        <ul className="grid gap-x-8 sm:grid-cols-3" data-id="element-319" data-mp="2ma05aa784dt2">
          {snakPrinciples.map((principle, i) => <li key={principle} className="flex items-center gap-3.5 border-t border-[var(--fg)]/10 py-4" data-id="element-320" data-mp="2hanljybnfmup" data-mpi={i}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[var(--brand)] text-[13px] font-bold text-white" data-id="element-321" data-mp="27j11dchc2dft">
                {i + 1}
              </span>
              <span className="text-[15px] font-semibold text-[var(--fg)]" data-id="element-322" data-mp="22i3l55fvvtgy">{principle}</span>
            </li>)}
        </ul>
      </InView>

      <InView delay={0.22} y={26} className="mt-8" data-id="element-323" data-mp="1tkb51z2c8hsi">
        <figure className="rounded-[28px] bg-white p-5 ring-1 ring-[var(--fg)]/5 sm:p-6" data-id="element-324" data-mp="1tlma027irvl7">
          <figcaption className="mb-5 flex flex-wrap items-center justify-between gap-x-6 gap-y-2" data-id="element-325" data-mp="1jy0fxlx5tqnb">
            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[var(--brand)]" data-id="element-326" data-mp="1nuwhzlwn3zsm">
              The REKOVELLE teaser Snak — one short story, screen by screen
            </span>
            <span className="flex items-center gap-3" data-id="element-327" data-mp="1eynkwdw4xd9n">
              {snakArc.map((step, i) => <React.Fragment key={step} data-id="element-328" data-mp="22o8bniyj5eth" data-mpi={i}>
                  {i > 0 && <ArrowRightIcon className="h-3.5 w-3.5 text-[var(--brand)]" aria-hidden="true" data-id="element-329" data-mp="27k6xozwdykqq" />}
                  <span className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-[var(--fg)]" data-id="element-330" data-mp="1svatjdxg9rve">{step}</span>
                </React.Fragment>)}
            </span>
          </figcaption>
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5" data-id="element-331" data-mp="2lk7zchkh5w79">
            {snakWalkthrough.map(item => <figure key={item.alt} className="flex flex-col items-center" data-id="element-332" data-mp="2qdszaf5mp093">
                <SnakStill screen={item.screen} alt={item.alt} className="aspect-[396/766] w-full max-w-[200px]" data-id="element-333" data-mp="ev6aakn2ej56" />
                <figcaption className="mt-3 text-center text-[12.5px] font-semibold leading-snug text-[var(--muted)]" data-id="element-334" data-mp="9vjwa8zewyvb">
                  {item.caption}
                </figcaption>
              </figure>)}
          </div>
        </figure>
      </InView>

      <InView delay={0.3} data-id="element-335" data-mp="3s4alk28xokxs">
        <p className="mt-10 flex items-center gap-3 text-[14px] font-semibold text-[var(--muted)]" data-id="element-336" data-mp="3s3j1noop8bnc">
          <span aria-hidden="true" className="h-[2px] w-8 rounded-full bg-[var(--brand)]" data-id="element-337" data-mp="3n60qrsr4fmcp" />
          Every interaction creates a signal.
        </p>
      </InView>
    </Section>;
}